import { useCallback, useEffect, useState } from "react";

// Decoupled GHL data hook. Lives outside useDashboard so the parallel
// Supabase migration work doesn't conflict with this code path.
//
// Phase 4 (2026-05-17): schedules dropped — recurring revenue is now
// derived from offer type + client monthlyRate, no GHL data needed.
//
// Fetches /api/ghl-invoices (Vercel serverless) and exposes:
//   invoices, fetchedAt, loading, error, refresh
export function useGhlSync() {
  const [state, setState] = useState({
    invoices: [],
    fetchedAt: null,
    loading: false,
    error: null,
  });

  const refresh = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const res = await fetch("/api/ghl-invoices", { headers: { Accept: "application/json" } });
      if (!res.ok) {
        const body = await res.text();
        throw new Error(`Sync failed (${res.status}): ${body.slice(0, 160)}`);
      }
      const data = await res.json();
      setState({
        invoices: data.invoices || [],
        fetchedAt: data.fetchedAt || new Date().toISOString(),
        loading: false,
        error: null,
      });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: String(e.message || e) }));
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...state, refresh };
}
